<div class="card">
  <div class="card-header d-flex align-items-center p-2">
    <h5 class="fw-bold pe-2">Welcome Letter:</h5>
    <ul class="nav nav-pills">
      @for (lang of languages; track lang) {
        <li class="nav-item">
          <a class="nav-link flag-button"
            [class.active]="activeTab === lang.code"
            (click)="onTabChange(lang.code)">
            <img [src]="lang.flag"
              [alt]="lang.label"
              class="flag-image"
              [class.active]="activeTab === lang.code">
            <p class="mt-2 mb-0">{{lang.code | uppercase}}</p>
          </a>
        </li>
      }
    </ul>
  </div>
  <div class="card-body">
    @if (alertInfo.show) {
      <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
        {{ alertInfo.message }}
      </ngb-alert>
    }
    <div class="tab-content" [formGroup]="form">
      @if (activeTab == 'eng') {
        <div class="form-group" [class.active]="activeTab == 'eng'">
          <input-field label="Subject" placeholder="Enter subject here..." [inputFormControl]="getSubjectInput()" [readonly]="readonlyTranslationsDetails"></input-field>
        </div>
      }
      @if (activeTab == 'eng') {
        <div class="form-group" [class.active]="activeTab == 'eng'">
          <content-toolbar label="Content" placeholder="Write your content here..." [contentFormControl]="getContentInput()"/>
        </div>
      }


      @if (activeTab == 'ita') {
        <div class="form-group" [class.active]="activeTab == 'ita'">
          <input-field label="Subject" placeholder="Enter subject here..." [inputFormControl]="getSubjectInput()" [readonly]="readonlyTranslationsDetails"></input-field>
        </div>
      }
      @if (activeTab == 'ita') {
        <div class="form-group" [class.active]="activeTab == 'ita'">
          <content-toolbar label="Content" placeholder="Write your content here..." [contentFormControl]="getContentInput()"/>
        </div>
      }


      @if (activeTab == 'spa') {
        <div class="form-group" [class.active]="activeTab == 'spa'">
          <input-field label="Subject" placeholder="Enter subject here..." [inputFormControl]="getSubjectInput()" [readonly]="readonlyTranslationsDetails"></input-field>
        </div>
      }
      @if (activeTab == 'spa') {
        <div class="form-group" [class.active]="activeTab == 'spa'">
          <content-toolbar label="Content" placeholder="Write your content here..." [contentFormControl]="getContentInput()"/>
        </div>
      }



      @if (!readonlyTranslationsDetails) {
        <div class="text-center mt-4">
          <button type="button" class="btn btn-success px-4 py-2" (click)="submitForm()">
            Save
          </button>
        </div>
      }
    </div>
  </div>
</div>